(() => {
  const PREFIX = '🔥 FREE GIFT ENDS IN';

  function updateGiftCountdown() {
    const elements = document.querySelectorAll(
      '.image-with-text__text p, .image-with-text__text'
    );

    let countdownElement = null;

    elements.forEach((el) => {
      if (el.textContent.includes('FREE GIFT ENDS IN')) {
        countdownElement = el;
      }
    });

    if (!countdownElement) return;

    const now = new Date();

    const midnight = new Date(now);
    midnight.setDate(midnight.getDate() + 1);
    midnight.setHours(0, 0, 0, 0);

    const remaining = midnight.getTime() - now.getTime();

    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    const time =
      String(hours).padStart(2, '0') + ':' +
      String(minutes).padStart(2, '0') + ':' +
      String(seconds).padStart(2, '0');

    countdownElement.textContent = `${PREFIX} ${time}`;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateGiftCountdown();
      setInterval(updateGiftCountdown, 1000);
    });
  } else {
    updateGiftCountdown();
    setInterval(updateGiftCountdown, 1000);
  }
})();